import {flow, types} from 'mobx-state-tree';
import * as consts from '../../consts';
import * as api from '../../services/api';

// tslint:disable
const PaginationModel = types.model('PaginationModel', {
  offset: types.optional(types.number, 0),
  limit: types.optional(types.number, 20),
  total: types.optional(types.number, 0),
  current: types.optional(types.number, 1)
});

export type UsersListActions = {
  loadEntries: (params: any) => void;
  receiveEntries: (data: any) => void;
};

const UserModel = types.model('UserModel', {
  id: types.identifierNumber,
  auth0UserId: types.string,
  sendbirdUserId: types.string,
  email: types.string,
  firstName: types.string,
  lastName: types.maybe(types.string),
  phone: types.maybe(types.string),
  countryCode: types.maybe(types.string),
  location: types.maybe(types.string),
  avatar: types.maybe(types.string),
  languages: types.maybe(types.string),
  role: types.maybe(
    types.model({
      id: types.identifierNumber,
      name: types.maybe(types.string),
      code: types.maybe(types.string)
    })
  )
});

export type UserModelType = typeof UserModel.Type;

const UsersListModel = types
  .model('UsersListModel', {
    isLoading: types.optional(types.boolean, false),
    pagination: types.optional(PaginationModel, {}),
    entries: types.map(UserModel)
  })
  .actions(self => {
    const withActions = (self as any) as UsersListActions;
    return {
      loadEntries: flow(function*(params: any) {
        self.isLoading = true;
        self.entries.clear();
        let {limit, offset, email, id, name} = params;

        limit = limit || consts.PAGINATION__DEFAULT_PER_PAGE;
        const response = yield api.getListUsers({
          _limit: limit,
          _offset: offset,
          email,
          id,
          name
        });
        if (response.status === 200 && response.data) {
          const {offset, total} = response.data.metadata;
          const users = response.data.users;
          self.pagination.limit = limit;
          self.pagination.offset = offset || 0;
          self.pagination.total = total;
          self.pagination.current = offset ? Math.ceil(offset / limit) + 1 : 1;
          withActions.receiveEntries(users);
        }
        self.isLoading = false;
      }),
      receiveEntries: (entries: any) => {
        if (!entries || entries.length === 0) {
          return;
        }
        const received = entries.reduce(
          (results: {[id: string]: UserModelType}, r: UserModelType) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        self.entries.merge(received);
      },
      clearEntries: () => {
        self.entries.clear();
      },
      bulkAssignUser: (
        userIds: number[],
        teamIds: number[],
        roleId: number
      ) => {
        self.isLoading = true;
        userIds.map((userId, userIdx) => {
          return teamIds.map((teamId, teamIdx) => {
            return api.assignUserToTeam(teamId, userId, roleId);
          });
        });
        self.isLoading = false;
      }
    };
  });

export default UsersListModel;

export type UsersListModelType = typeof UsersListModel.Type;



// WEBPACK FOOTER //
// ./src/models/UsersListModel/UsersListModel.ts